import { render, staticRenderFns } from "./contracted-project-list.html?vue&type=template&id=452627e7&scoped=true&external"
import script from "./contracted-project-list.js?vue&type=script&lang=js&external"
export * from "./contracted-project-list.js?vue&type=script&lang=js&external"
import style0 from "./contracted-project-list.scss?vue&type=style&index=0&id=452627e7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452627e7",
  null
  
)

export default component.exports